export const gaming = {
  title: "AI Gaming Generator",
  description: "Create games for your fans",
  
  typeSelection: {
    title: "Choose Game Type",
    description: "AI helps create the game based on your theme, but you can manually edit it anytime.",
    types: {
      quiz: {
        name: "Quiz",
        description: "Interactive quiz with questions and answers"
      },
      wordScramble: {
        name: "Word Scramble",
        description: "Guess words from scrambled letters"
      },
      memory: {
        name: "Memory Game",
        description: "Match pairs in a memory game"
      },
      giveaway: {
        name: "Giveaway / Challenge",
        description: "Raffle or challenge for followers"
      },
      swipePoll: {
        name: "Swipe Poll",
        description: "Quick voting with swipes"
      }
    },
    chooseButton: "Choose"
  },
  
  aiSetup: {
    title: "AI Setup",
    theme: "Theme / Keywords",
    themePlaceholder: "e.g., Home workout plans",
    language: "Language",
    questionCount: "Number of Questions",
    wordCount: "Number of Words",
    imageCount: "Number of Images",
    difficulty: "Difficulty Level",
    difficultyLevels: {
      easy: "Easy",
      medium: "Medium",
      hard: "Hard"
    },
    optionsCount: "Number of Poll Options",
    generateButton: "AI Generate Game",
    generating: "Generating..."
  },
  
  manualEdit: {
    title: "Manual Edit",
    addQuestion: "Add New Question",
    addWord: "Add New Word",
    addImage: "Add New Image",
    addOption: "Add New Option",
    editQuestion: "Edit Question",
    deleteQuestion: "Delete Question",
    points: "Points",
    timeLimit: "Time Limit (seconds)",
    coverImage: "Cover Image",
    backgroundColor: "Background Color",
    buttonColor: "Button Color"
  },
  
  access: {
    title: "Access and Reward",
    whoCanPlay: "Who can play?",
    levels: {
      public: "All visitors",
      subscribers: "Subscribers only",
      vip: "VIP subscribers only",
      productOwners: "Only those who purchased this product"
    },
    selectProduct: "Select Product",
    reward: "What does the winner/participant get?",
    rewardTypes: {
      coupon: "Coupon for a product",
      contentAccess: "Exclusive content access",
      subscriptionUpgrade: "Automatic subscription upgrade",
      leaderboardOnly: "Point collection / Leaderboard only"
    },
    discountPercent: "Discount (%)",
    selectRewardProduct: "Select Reward Product",
    selectContent: "Select Content",
    subscriptionTier: "Subscription Tier",
    trialDays: "Trial Period (days)"
  },
  
  timing: {
    title: "Timing",
    startDate: "Start Date",
    endDate: "End Date",
    autoPublish: "Auto-publish Results"
  },
  
  visibility: {
    title: "Visibility",
    showOnLanding: "Public (visible on landing page)",
    showOnDashboard: "Subscriber dashboard only",
    linkOnly: "Link only"
  },
  
  preview: {
    title: "Preview",
    description: "This is how the game will look for your fans",
    generatedBanner: "Auto-generated banner"
  },
  
  actions: {
    saveDraft: "Save as Draft",
    publishNow: "Publish Now",
    schedulePublish: "Schedule Publishing",
    cancel: "Cancel",
    back: "Back",
    next: "Next"
  },
  
  stats: {
    title: "Results and Statistics",
    participants: "Participants",
    averageScore: "Average Score",
    topPlayers: "Top Players",
    conversionRate: "Conversion Rate",
    productPurchases: "Product Purchases",
    subscriptionUpgrades: "Subscription Upgrades"
  },
  
  toast: {
    gameGenerated: "Game successfully generated!",
    gameSaved: "Game saved!",
    gamePublished: "Game published!",
    error: "An error occurred",
    fillRequired: "Fill in the required fields!"
  }
};
